export default function pluralize(count, word, suffix="s") {
  return count === 1 ? word : `${word}${suffix}`;
}